import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss'],
})
export class ConfirmPopupComponent {
  mainTitle: string = 'Notice';
  title: string = 'Are you sure you want to continue?';
  yesText: string = 'Yes';
  noText: string = 'No';
  iconClass: string = 'fa-solid fa-bell';
  isSuccess: boolean = false;
  isDanger: boolean = false;
  hideArrow: boolean = false;
  yesIcon: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data) {
      if (this.data.mainTitle) this.mainTitle = this.data.mainTitle;
      if (this.data.title) this.title = this.data.title;
      if (this.data.yesText) this.yesText = this.data.yesText;
      if (this.data.noText) this.noText = this.data.noText;
      if (this.data.iconClass) this.iconClass = this.data.iconClass;
      if (this.data.isSuccess) this.isSuccess = this.data.isSuccess;
      if (this.data.isDanger) this.isDanger = this.data.isDanger;
      if (this.data.hideArrow !== undefined) this.hideArrow = this.data.hideArrow;
      if (this.data.yesIcon) this.yesIcon = this.data.yesIcon;
    }
  }

  closeModal() {
    this.dialogRef.close();
  }
}
